import { createFileRoute } from '@tanstack/react-router';

import { LegalEntityDetail } from '@/features/legal-entities/LegalEntityDetail';
import { buildHead } from '@/utils/html';

export const Route = createFileRoute('/_authenticated/entities/$entityId')({
  component: EntityDetailPage,
  head: () => buildHead('entityDetail'),
});

function EntityDetailPage() {
  const { entityId } = Route.useParams();
  return <LegalEntityDetail entityId={entityId} />;
}
